import config from 'react-global-configuration';
import { AppOptions } from '../types';

export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
export const USE_SENTRY = process.env.REACT_APP_SENTRY_ENABLED?.toLowerCase() === "true";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const REACT_APP_VERSION = process.env.REACT_APP_VERSION;

export const MULTILINGUAL = process.env.REACT_APP_MULTILINGUAL?.toLowerCase() === 'true' || false;
export const DEFAULT_LANGUAGE = 'en';
export const SITE_NAME = 'InfoNTD';

export const INFOLEP_DOMAIN = 'leprosy_information_org';
export const INFONTD_DOMAIN = 'infontd_org';

export const INFOLEP_HOSTS = [
  'infolep.devinc.eu',
  'staging.infolep.org',
  'staging.leprosy-information.org',
  'accept.infolep.org',
  'accept.leprosy-information.org',
  'infolep.org',
  'www.infolep.org',
  'leprosy-information.org',
  'www.leprosy-information.org',
];

export const INFONTD_HOSTS = [
  'infontd.devinc.eu',
  'staging.infontd.org',
  'accept.infontd.org',
  'infontd.org',
  'www.infontd.org',
];

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

export let API_URL = process.env.REACT_APP_API_URL || "https://infontd.org";

// Searchkit host url.
export let SEARCHKIT_HOST_URL = process.env.REACT_APP_SEARCHKIT_HOST_URL || '/api-proxy/elasticsearch-proxy?_api_proxy_uri=';

export let APP_OPTIONS: AppOptions = {
  apiUrl: API_URL,
  element: '',
  parameters: {
    env: 'production',
    searchPath: '/search',
    ocularDBPath: '/ocular',
    searchkitIndexAllContent: 'elasticsearch_index_drupal_resources',
    searchkitIndexOcularDB: 'elasticsearch_index_drupal_ocular_db',
    showFullSearch: true,
    ocularDB: false,
    ocularDBCtaLink: '/sites/default/files/2025-04/250429%20FAQs%20%20Quick%20guide%20for%20upload%20to%20ILEP%20Ocular%20Database.pdf',
    searchDecay: 0.75,
  }
};

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0; // xs
export const SCREEN_TABLET = 576; // sm
export const SCREEN_NORMAL = 768; // md
export const SCREEN_WIDE = 992; // lg
export const SCREEN_HUGE = 1240; // xl

// Use config to share static configuration between components and packages.
config.set({
  'SITE_NAME': SITE_NAME,
  'MULTILINGUAL': MULTILINGUAL,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'API_URL': API_URL,
  'REACT_APP_VERSION': REACT_APP_VERSION,
  'PAGE_TRANSITION_SPEED': 100,
  // Set freeze to false to allow overwriting the configs based on the
  // options passed to window.reactFrontend
}, { freeze: false });

export function saveConstants(options: AppOptions) {
  APP_OPTIONS = options;

  if (options.parameters.env) {
    APP_ENV = options.parameters.env;
  }

  if (options.apiUrl) {
    API_URL = options.apiUrl;
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    API_URL = 'http://localhost:3000/api';
    SEARCHKIT_HOST_URL = 'http://localhost:3000/search';
  }

  // Update the config.
  config.set({
    'SITE_NAME': SITE_NAME,
    'MULTILINGUAL': MULTILINGUAL,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'API_URL': API_URL,
    'REACT_APP_VERSION': REACT_APP_VERSION,
    'PAGE_TRANSITION_SPEED': 100,
  });
}

export const MAIL_INFONTD = 'info@infontd.org';
export const MAIL_INFOLEP = 'info@infolep.org';

// Bibcite.
export const BIBCITE_CONTRIBUTORS_MAX_LENGTH = 3;
